import { ActionStatus } from '@/application/types';
import { ProjectSearchState } from '../types';

export const projectSearchStateDefaults: ProjectSearchState = {
  hasSearchBeenTriggered: false,
  hasSearchResultedIn0Results: false,
  lastSearchTerm: '',
  projects: [],
  getProjectsByBaseProjectNumberStatus: ActionStatus.None,
};
